<template>
	<!--
	<cardHeader title="" class="bg-white header-elements-sm-inline pl-0 pb-4">
		<div class="header-elements">
			<router-link :to="{ name : 'users-add'}" active-class="active" class="btn btn-primary btn-labeled btn-labeled-left">
                <b><i class="icon-plus22"></i></b> New User
            </router-link>
		</div>
	</cardHeader>
	-->
	<div></div>
</template>
<script>

import uiCard from '@components/pages/elements/card'
import uibutton  from '@components/ui/button.vue'

export default {
	components : {
		'cardHeader' : uiCard.cardHeader,
		uibutton
	},
    props: {
		filters : {
			type: Object,
			required : true
		},
		options : {
			type: Object,
			required : true
		}
    },
    watch: {
    },
    data() {
		return {
			isExporting : false
		}
	},

	mounted () {
    },
    computed: {
		data(){
			return {
				options : this.options,
				filters : this.filters
			}
		}
    },
    methods : {		
    }
};
</script>
